<template>
<div class="chapter">
<div class="inner_page">
<p class="p3"><i></i> </p>
<p class="p6"><i>Dear Reader,</i></p>
<p class="p3"> </p>
<p class="p7"><i>Perhaps within all of us is a spark of something we call destiny, some inner yearning that enables us to bravely push forward each day, sure that something wondrous awaits. Casey O'Reilly has been waiting thirty-one years for hers to make an appearance, and when destiny finally calls she's unprepared.</i></p>
<p class="p7">Heaven on Earth <i>is the story of a very reluctant heroine, an ordinary woman who experiences an extraordinary love. It began with my own visit to one of my favorite cities, Santa Fe. There is a reason it is known as "The City Different," for there is magic in the air and in the land. Steeped in an ancient culture, it seemed to call to me to write about it, and one day, while sitting on a rock and looking out to the breathtaking mountains as lightning flashed in the distance, I imagined the beginning of the book you are now holding. All I saw was the scene where the hero and heroine meet, yet I was filled with excitement, for I felt I was about to push the boundaries of time travel once again by having not one, but two travelers journeying through time to discover their heroic nature and the magic of love.</i></p>
<p class="p7"><i>These two characters captured my imagination in Santa Fe, and in the following months, while I wrote, they also entered my heart. I hope you will invite them into yours for a short while and watch as they each discover it's true… there is such a thing as destiny. Maybe we only have to be open to it.</i></p>
<p class="p8"> </p>
<p class="p9"><i>Kindest regards,</i></p>
<p class="p9"><i>Constance O’Day</i></p>
<p class="p5"><i></i> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section3.vue?7177a776